import _, { map } from 'lodash';
import {Vector as VectorLayer } from 'ol/layer';
import {poiBankLayer} from './POI/Bank';
import {poiSchoolLayer} from './POI/School';
import {poiHospitalLayer} from './POI/Hospital';
import {poiGasStationLayer} from './POI/PetrolPump';
import {poiFactoryLayer} from './POI/Factory';
import {poiShoppingMarketLayer} from './POI/ShoppingMarket';
import {getPOILayer} from './POI/POIConnect';
import {getRoadLayer} from './RoadNetwork';
import {Style,Icon} from 'ol/style';


const POIIconInfo = [
        {
            'Name' : 'Banks',
            'src' : 'data/new/bank-icon-poi.svg',
            //'src' : 'data/icons/24px/bank.png',
            'color' : '#964B00'
        },
        {
            'Name' : 'Schools',
            'src' : 'data/new/school-icon-poi.svg',
            'color' : '#3F0071'
        },
        {
            'Name' : 'Hospitals',
           // 'src' : 'data/icons/24px/hospital.png',
            'src' : 'data/new/hospital-icon-poi.svg',
            'color' : '#BA274A'
        },
        {
            'Name' : 'Petrol pumps',
            'src' : 'data/new/petrolPump-icon-poi.svg',
            'color' : '#171A1FFF'
        },
        {
            'Name' : 'CNG',
            'src' : 'data/new/cng-icon-poi.svg',
            'color' : '#367E18'
        },
        {
            'Name' : 'Industrial Centers',
            'src' : 'data/new/industrialCenter-icon-poi.svg',
            'color' : '#3A86FF'
        },
        {
            'Name' : 'APMCS',
            'src' : 'data/new/apmc-icon-poi.svg',
            'color' : '#E21818'
        },
        {
            'Name' : 'Transport Nagar',
            'src' : 'data/new/transportNagar-icon-poi.svg',
            'color' : '#BF40BF'
            
        }
]


export function AddPOILayer(name,stateData,setStateData,layers,setLayers,loader,setLoader){
    let map = stateData.mapObject;
    let poiObj = _.find(POIIconInfo,{'Name' : name});

    // console.log(poiObj);
    setLoader({...loader,'active':true,'content':'Loading '+name+' POI Layer'});
    // var POIlayer = getPOILayer(name,stateData.selected,poiObj.src,poiObj.color);
    var POIlayer = getPOILayer(name,map,stateData.selected,poiObj.src,poiObj.color);

    POIlayer.on('postrender',(evt)=>{
        let l = layers;
        l[name] = POIlayer;
        if(!_.has(layers,name)){
        setLayers(l);
        }
        // console.log(evt);

        setLoader({...loader,'active':false});
    });
    setTimeout(function() { setLoader({...loader,'active':false}) }, 5000);
    // console.log('POI Layers:',layers);
    map.addLayer(POIlayer);
    // console.log('POILayer called');
    setStateData({...stateData,'mapObject':map});

    //return POIlayer;
}

export function RemovePOILayer(name,stateData,setStateData,layers,setLayers,loader,setLoader){
    setLoader({...loader,'active':true,'content':'Removing '+name+' POI Layer'});
    if(_.has(layers,name)){
        let map = stateData.mapObject;
        if(!_.isEmpty(map)){
            map.removeLayer(layers[name]);
            delete layers.name;
            setLayers(layers);
            setStateData({...stateData,'mapObject':map});
        }
    }
    // console.log('RemovePOILayer called');
    setLoader({...loader,'active':false});
}


export function AddRoadLayer(name,stateData,setStateData,layers,setLayers,loader,setLoader){
    let map = stateData.mapObject;
    setLoader({...loader,'active':true,'content':'Loading '+name+' Road Layer'});
    var Roadlayer = getRoadLayer(stateData.selected,name);
    Roadlayer.on('postrender',()=>{
        let l = layers;
        l[name] = Roadlayer;
        if(!_.has(layers,name)){
            setLayers(l);
        }
        setLoader({...loader,'active':false});
    });
    setTimeout(function() { setLoader({...loader,'active':false}) }, 10000);
    // console.log('road Layers:',layers);
    map.addLayer(Roadlayer);
    // console.log('AddRoadLayer called');
    setStateData({...stateData,'mapObject':map});
}

export function RemoveRoadLayer(name,stateData,setStateData,layers,setLayers,loader,setLoader){
    setLoader({...loader,'active':true,'content':'Removing '+name+' Road Layer'});
    if(_.has(layers,name)){
        let map = stateData.mapObject;
        map.removeLayer(layers[name]);
        delete layers.name;
        setLayers(layers);
        setStateData({...stateData,'mapObject':map});
        setLoader({...loader,'active':false});
    }
    setLoader({...loader,'active':false});

    // console.log('RemoveRoadLayer called');
}
